import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, inject } from '@angular/core';
import {AccessibilityService} from '../services/accessibility.service';

@Directive({
    selector: '[a11yPageTitleLevel]',
    standalone: false
})
export class PageTitleLevelDirective implements AfterViewInit, OnDestroy, OnChanges {
    private accessibilityService = inject(AccessibilityService);
    private elementRef = inject(ElementRef);

    @Input() pageTitleLevel = 1;

    ngAfterViewInit() {
        this.accessibilityService.setPageTitle(this.elementRef.nativeElement.textContent, this.pageTitleLevel);
    }

    ngOnDestroy() {
        this.accessibilityService.clearPageTitle(this.elementRef.nativeElement.textContent, this.pageTitleLevel);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes.pageTitleLevel.firstChange && changes.pageTitleLevel.currentValue > -1) {
            this.accessibilityService.setPageTitle(this.elementRef.nativeElement.textContent, changes.pageTitleLevel.currentValue);
        }
    }
}
